// 项目动态封面占位图
export const placeholderImg = 'https://admin.gdyfpt.com/file/pic/20201229202712854635.jpg'